import { get } from 'lodash';

import template from './auth-form.jade'
import validation from '../../../scripts/services/validation';
import checkEmailResponseStatuses from './check-email-response-statuses';

export default {
  template,
  bindings: {
    mergeData: '=',
    enterEmailData: '=',
    submitting: '=',
    onRemindPassword: '&',
  },
  controller: function (
    $scope, $q, apiService, authService, remoteValidationService, analyticsService, popupService, addFormService, deviceService,
  ) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    const REQUEST_CANCELLED = -1;

    let checkEmailStatus = null;
    this.email = '';

    this.checkEmailRequestCanceller = null;
    this.handleEmailChange = () => {
      checkEmailStatus = null;
      if (this.checkEmailRequestCanceller) {
        this.checkEmailRequestCanceller.resolve();
        this.checkEmailRequestCanceller = null;
      }
      // К сожалению remote ошибки скидываются позже, чем срабатывает хендлер ng-change
      // Если email валидный с точки зрения фронта, но есть ошибка от бекенда, то выполняем перепроверку email
      if (this.form.email.$valid || this.form.email.$error.remote) {
        this.checkEmailRequestCanceller = $q.defer();
        apiService.checkEmail({
          params: {
            email: this.email
          },
          timeout: this.checkEmailRequestCanceller.promise,
        }).then(response => {
          this.checkEmailRequestCanceller = null;

          const status = response.data.data.status;
          if (status === checkEmailResponseStatuses.invalidEmail) {
            this.form.remoteValidator.setValidators({key: 'checkEmail', status});
          } else {
            checkEmailStatus = status;
            this.form.$setPristine();
            if (this.isLogin()) {
              analyticsService.authEmailFound(addFormService.ad.isByHomeowner);
              this.loginPassword = '';
              this.passwordObsoleteError = null;
            } else if (this.isRegistration()) {
              analyticsService.authEmailNotFound(addFormService.ad.isByHomeowner);
              this.name = '';
              this.phoneNumber = {
                countryCode: '+7',
                number: null,
                validationCode: null,
              };
              this.phoneState = this.phoneStates.codeNotSent;
              this.repeatedCodeSendingDisabled = false;
              this.registrationPassword = '';
              this.passwordErrorMessage = null;
            }
          }
        }).catch(error => {
          if (error.status !== REQUEST_CANCELLED) {
            this.checkEmailRequestCanceller = null;
            popupService.openPopup('authError', {popupData: {}});
          }
        });
      }
    };

    this.isLogin = () => checkEmailStatus === checkEmailResponseStatuses.emailAlreadyExists;

    this.isRegistration = () => checkEmailStatus === checkEmailResponseStatuses.ok;

    this.$postLink = () => {
      this.form.remoteValidator = remoteValidationService.getInstance(this.form);
      this.form.remoteValidator.map = data => {
        const result = {
          fields: {},
          form: {},
          sections: {},
        };

        if (data.key === 'checkEmail' && data.status === checkEmailResponseStatuses.invalidEmail) {
          result.fields.email = {
            triggers: 'email',
            messages: {code: 'message', message: 'Укажите корректный email'},
          };
        }

        if (this.isLogin()) {
          if (data.key === 'Password') {
            result.fields.loginPassword = {
              triggers: 'loginPassword',
              messages: {code: 'invalidPassword'},
            };
          }
        } else if (this.isRegistration()) {
          if (data.key === 'sendPhoneConfirmCode') {
            result.fields.phoneNumber = {
              triggers: 'phoneNumber',
              messages: {code: 'message', message: data.message},
            };
          }

          if (data.key === 'validatePhoneConfirmCode') {
            result.fields.code = {
              triggers: 'code',
              messages: {code: 'message', message: data.message},
            };
          }

          // TODO после фикса проблемы с шириной тултипа и использованием remoteValidator.setValidators
          // для API validatePassword этот код будет обрабатывать и показывать ошибку
          if (data.key === 'validatePassword') {
            result.fields.registrationPassword = {
              triggers: 'registrationPassword',
              messages: {code: 'message', message: data.message},
            };
          }


          if (data.key === 'registration') {
            if (data.data.errors[0].code === 'EmailAlreadyExists') {
              this.handleEmailChange();
            }
            // TODO проверить валидацию других полей
          }
        }

        return result;
      };

      this.emailValidation = validation(this.form, 'email', {
        required: 'Не заполнен "E-mail"',
        email: 'Укажите корректный email',
      });

      // Логин

      this.loginPasswordValidation = validation(this.form, 'loginPassword', {
        required: 'Пароль не заполнен',
      });

      // Регистрация

      this.nameValidation = validation(this.form, 'name', {
        required: 'Укажите имя',
      });

      this.phoneNumberValidation = validation(this.form, 'phoneNumber', {
        required: 'Укажите мобильный телефон',
      });

      this.codeValidation = validation(this.form, 'code', {
        required: 'Введите код',
        minlength: 'Минимальное количество символов – 4',
      });

      this.registrationPasswordValidation = validation(this.form, 'registrationPassword', {
        required: 'Придумайте пароль',
      });
    };

    this.submit = () => {
      if (this.isRegistration()) {
        register();
      } else if (this.isLogin()) {
        login();
      }
    };

    // Логин

    this.remindPassword = email => {
      this.onRemindPassword({$email: email});
      analyticsService.forgotPassword();
    };

    this.resetLoginForm = () => {
      this.loginPassword = '';
      this.passwordObsoleteError = null;
      this.form.$setPristine();
    };

    const login = () => {
      this.submitting = true;
      authService.login(
        this.email,
        this.loginPassword,
      ).catch((error) => {
        if (error.errors[0]) {
          if (error.errors[0].code === 'passwordWarning') {
            this.passwordObsoleteError = error.errors[0].message;
          } else {
            this.form.remoteValidator.setValidators(error.errors[0]);
          }
        } else {
          popupService.openPopup('authError', {popupData: {}});
        }
      }).finally(() => {
        this.submitting = false;
      });
    };

    // Регистрация

    // В любой момент времени может быть только одно из следующих состояний
    this.phoneStates = {
      codeNotSent: 'codeNotSent',
      sendPhoneConfirmCodeRequestInProgress: 'sendPhoneConfirmCodeRequestInProgress',
      codeSent: 'codeSent',
      validatePhoneConfirmCodeRequestInProgress: 'validatePhoneConfirmCodeRequestInProgress',
      phoneVerified: 'phoneVerified',
    };

    this.onNumberChange = () => {
      this.phoneState = this.phoneStates.codeNotSent;
      this.repeatedCodeSendingDisabled = false;
      if (this.validatePhoneConfirmCodeRequestCanceller) {
        this.validatePhoneConfirmCodeRequestCanceller.resolve();
        this.validatePhoneConfirmCodeRequestCanceller = null;
      }
    };

    const getFullNumber = () => this.phoneNumber.countryCode + this.phoneNumber.number;

    let sendPhoneConfirmCodePromise = null;
    this.sendCode = repeatedRequest => {
      this.form.phoneNumber.$setTouched();

      if (this.form.phoneNumber.$valid) {
        if (!repeatedRequest) {
          this.phoneState = this.phoneStates.sendPhoneConfirmCodeRequestInProgress;
        }
        this.repeatedCodeSendingDisabled = true;

        sendPhoneConfirmCodePromise = apiService.sendPhoneConfirmCode(getFullNumber()).then(() => {
          this.phoneState = this.phoneStates.codeSent;
        }).catch(error => {
          this.phoneState = this.phoneStates.codeNotSent;
          this.form.remoteValidator.setValidators({
            key: 'sendPhoneConfirmCode',
            message: get(error, 'data.message', 'Ошибка на сервере'),
          });
        });
      }
    };

    this.onCountDownFinished = () => {
      this.repeatedCodeSendingDisabled = false;
    };

    let validatePhoneConfirmCodePromise = null;
    this.validatePhoneConfirmCodeRequestCanceller = null;
    this.onCodeChange = () => {
      if (this.validatePhoneConfirmCodeRequestCanceller) {
        this.validatePhoneConfirmCodeRequestCanceller.resolve();
        this.validatePhoneConfirmCodeRequestCanceller = null;
      }

      if (this.form.code.$valid) {
        this.validatePhoneConfirmCodeRequestCanceller = $q.defer();
        this.form.code.$setTouched();
        if (!this.form.remoteValidator) {
          this.form.remoteValidator = remoteValidationService.getInstance(this.form);
        }
        this.phoneState = this.phoneStates.validatePhoneConfirmCodeRequestInProgress;
        validatePhoneConfirmCodePromise = apiService.validatePhoneConfirmCode({
          confirmationCode: this.phoneNumber.validationCode,
          phoneNumber: getFullNumber(),
        }, {
          timeout: this.validatePhoneConfirmCodeRequestCanceller.promise,
        }).then(() => {
          this.validatePhoneConfirmCodeRequestCanceller = null;
          this.phoneState = this.phoneStates.phoneVerified;
          analyticsService.authPhoneConfirmation();
        }).catch(error => {
          if (error.status !== REQUEST_CANCELLED) {
            this.phoneState = this.phoneStates.codeSent;
            this.validatePhoneConfirmCodeRequestCanceller = null;
            this.form.remoteValidator.setValidators({
              key: 'validatePhoneConfirmCode',
              message: get(error, 'data.message', 'Ошибка на сервере'),
            });
          }
        });
      }
    };

    const handlePasswordValidationError = error => {
      this.passwordErrorMessage = get(error, 'data.message', 'Ошибка на сервере');
      // TODO использовать remoteValidator вместо passwordErrorMessage
      // после решения проблемы с позиционированием/шириной тултипа валидации
      // this.form.remoteValidator.setValidators({key: 'validatePassword', message: get(error, 'data.message', 'Ошибка на сервере')});
    };

    this.passIsShown = false;
    this.passwordErrorMessage = null;

    // Для валидации чекбокса в навигации блока "Контакты", нужно смотреть, есть ли passwordErrorMessage
    $scope.$watch(() => this.passwordErrorMessage, (passwordErrorMessage) => {
      if (this.form.registrationPassword) {
        this.form.registrationPassword.passwordErrorMessage = passwordErrorMessage;
      }
    });

    let validatePasswordRequestCanceller = null;
    this.validatePassword = () => {
      if (validatePasswordRequestCanceller) {
        validatePasswordRequestCanceller.resolve();
        validatePasswordRequestCanceller = null;
      }

      if (this.form.registrationPassword.$valid) {
        validatePasswordRequestCanceller = $q.defer();
        apiService.validatePassword(this.registrationPassword, {
          timeout: validatePasswordRequestCanceller.promise,
        }).then(response => {
          validatePasswordRequestCanceller = null;

          if (response.data.value !== 'Success') {
            return $q.reject(response);
          }
        }).catch(error => {
          if (error.status !== REQUEST_CANCELLED) {
            validatePasswordRequestCanceller = null;
            handlePasswordValidationError(error);
          }
        });
      }
    };

    const register = () => {
      if (this.phoneState === this.phoneStates.codeNotSent) {
        this.sendCode();
      } else if (this.phoneState === this.phoneStates.validatePhoneConfirmCodeRequestInProgress) {
        validatePhoneConfirmCodePromise.then(() => {
          doRegister();
        });
      } else if (this.phoneState === this.phoneStates.phoneVerified) {
        doRegister();
      }
    };

    const doRegister = () => {
      if (this.form.$valid && !this.passwordErrorMessage) {
        analyticsService.trySubmitRegistration();

        if (validatePasswordRequestCanceller) {
          validatePasswordRequestCanceller.resolve();
          validatePasswordRequestCanceller = null;
        }

        this.submitting = true;
        authService.register({
          firstName: this.name,
          phone: this.phoneNumber,
          email: this.email,
          password: this.registrationPassword,
          userType: addFormService.ad.isByHomeowner ? 'basic' : 'agent',
        }).then(() => {
          this.submitting = false;
          addFormService.ad.phones = [{
            number: this.phoneNumber.number,
            countryCode: this.phoneNumber.countryCode,
          }];
        }).catch(error => {
          if (error.status === 400) {
            if (error.data.errors[0].key === 'PasswordError') {
              handlePasswordValidationError(error);
            } else if (error.data) {
              this.passwordErrorMessage = null;
              this.form.remoteValidator.setValidators({key: 'registration', data: error.data});
            }
          }
          this.submitting = false;
        });
      }
    };
  }
};
